import { Routes } from '@angular/router';
import { protectedGuards } from './core/auth/auth.guard';
import { authRoutes } from './features/auth';
import { bhvShellRoutes } from './features/bhv';
import { gadgetsRoutes, gadgetsShellRoutes } from './features/gadgets';
import { profileRoutes, profileShellRoutes } from './features/profile';
import { restaurantRoutes, restaurantShellRoutes } from './features/restaurant';

export const routes: Routes = [
  ...authRoutes,
  {
    path: '',
    canActivate: protectedGuards,
    canActivateChild: protectedGuards,
    loadComponent: () =>
      import('./layout/application-shell/bottom-nav-shell').then((module) => module.BottomNavShell),
    children: [
      ...restaurantShellRoutes,
      ...gadgetsShellRoutes,
      ...bhvShellRoutes,
      ...profileShellRoutes,
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'restaurant',
      },
    ],
  },
  ...restaurantRoutes,
  ...gadgetsRoutes,
  ...profileRoutes,
  {
    path: '**',
    redirectTo: 'restaurant',
  },
];
